import { SkeletonLoader } from "./SkeletonLoader";

export const ListViewSkeletonLoader = () => (
  <div className="flex flex-col gap-2 p-4">
    <SkeletonLoader
      rows={2}
      height="26px"
      wrapperClassName="!px-0"
      loaderClassName="rounded-2xl"
    />
    <SkeletonLoader
      rows={1}
      height="26px"
      width="310px"
      wrapperClassName="!px-0"
      loaderClassName="rounded-2xl"
    />
  </div>
);
